import styled, { css } from "styled-components";
import { border, color, typeStyle, units } from "@m/alchemy-theme";
export const CardFooter = styled.div `
  color: ${color("typeBody")};
  ${typeStyle("captionM")};
  padding: ${units(2)} ${units(3)} ${units(3)} ${units(3)};
  width: 100%;

  ${({ backgroundColor }) => backgroundColor &&
    css `
      background-color: ${backgroundColor};
    `};

  ${({ hasBorder }) => hasBorder &&
    css `
      border-top: ${border()};
    `};
`;
